<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    :help-text="helpText"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
import {MODELS} from "../../services/models";
import {ENUMS} from "../../services/enums";

export default {
  name: "FilterSources",
  props: {
    label: {
      type: String,
      default: "Source"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].sources;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sources",
          value
        ]);
      }
    },
    options() {
      return [
        {id: null, label: "No filter"},
        {id: MODELS.Import.class_name, label: "Imports"},
        {id: MODELS.IntegrationPhoneNumber.class_name, label: "Phone Integration"},
        {id: ENUMS.IntegrationTypeEnum.LaunchControl.value, label: "Launch Control Integration"},
        {id: MODELS.Webhook.class_name, label: "Webhooks"},
        {id: MODELS.CallScript.class_name, label: "Call Scripts"},
      ];
    },
    text() {
      if (this.filterValue === MODELS.Import.class_name) return "Source: Imports";
      if (this.filterValue === MODELS.IntegrationPhoneNumber.class_name) return "Source: Phone Integration";
      if (this.filterValue === ENUMS.IntegrationTypeEnum.LaunchControl.value) return "Source: Launch Control Integration";
      if (this.filterValue === MODELS.Webhook.class_name) return "Source: Webhooks";
      if (this.filterValue === MODELS.CallScript.class_name) return "Source: Call Scripts";
      return null;
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
